import type { ComponentProps } from '@enonic/react-components'
import * as React from 'react'
import { Section, Container } from '../primitives'

interface KeyFiguresItem {
  figure: string
  description: string
}

export interface KeyFiguresData extends Record<string, unknown> {
  contained: boolean
  items: KeyFiguresItem[]
}

export const KeyFigures = (props: ComponentProps) => {
  const { contained, items } = props.data as KeyFiguresData

  if (!items || items.length === 0) return null

  return (
    <Section>
      <Container className="gap-y-8 md:gap-y-0">
        {contained ? (
          items.map((item, index) => (
            <figure
              key={index}
              className="col-span-3 flex flex-col items-center text-center rounded-xl bg-blue-900 text-blue-300 p-8"
            >
              <p className="text-5xl md:text-7xl font-bold">{item.figure}</p>
              <figcaption className="text-xs md:text-2xl">{item.description}</figcaption>
            </figure>
          ))
        ) : (
          <div className="col-span-full flex flex-col md:flex-row md:justify-between md:items-start gap-y-8 md:gap-x-8">
            {items.map((item, index) => (
              <figure
                key={index}
                className="flex flex-col items-center text-center text-slate-700"
              >
                <p className="text-5xl md:text-7xl font-bold">{item.figure}</p>
                <figcaption className="text-xs md:text-2xl">{item.description}</figcaption>
              </figure>
            ))}
          </div>
        )}
      </Container>
    </Section>
  )
}
